import {RouterModule, Routes} from '@angular/router';
import {RegistrationComponent} from "./registration/registration.component";
import {LoginPageComponent} from "./login-page/login-page.component";
import {NgModule} from "@angular/core";
import {ForgotPasswordComponent} from "./forgot-password/forgot-password.component";
import {ResetPasswordComponent} from "./reset-password/reset-password.component";
import {isAuthenticatedGuard} from "./guards/is-authenticated.guard";
import {isAuthenticatedAdminGuard} from "./guards/is-authenticated-admin.guard";
import {feeMemberActiveGuard} from "./guards/fee-member-active.guard";
import {ResetTokenExistComponent} from "./reset-token-exist/reset-token-exist.component";
import {AdminPageComponent} from "./admin-page/admin-page.component";
import {CommonComponent} from "./common/common.component";
import {CardsComponent} from "./cards/cards.component";
import {EditProfileCardComponent} from "./profile-card/edit-profile-card/edit-profile-card.component";
import {ErrorPageComponent} from "./error-page/error-page.component";
import {CardsByQrComponent} from "./cards-by-qr/cards-by-qr.component";
import {ContentComponent} from "./admin-page/content/content.component";
import {EditContentComponent} from "./admin-page/edit-content/edit-content.component";
import {AdminLoginPageComponent} from "./admin-login-page/admin-login-page.component";
import {AdminContainerComponent} from "./admin-container/admin-container.component";
import {qrCodeGuard} from "./guards/qr-code.guard";
import {HashtagComponent} from "./admin-page/hashtag/hashtag.component";
import {EditHashtagComponent} from "./admin-page/edit-hashtag/edit-hashtag.component";
import {AboutUsComponent} from "./about-us/about-us.component";
import {HomepageComponent} from "./homepage/homepage.component";
import {PrivacyPolicyComponent} from "./privacy-policy/privacy-policy.component";
import {CardsHistoryComponent} from "./cards-history/cards-history.component";
import {CartComponent} from "./cart/cart.component";
import {ProductsComponent} from "./products/products.component";
import {ContactUsComponent} from "./contact-us/contact-us.component";
import {ProductDetailsPageComponent} from "./products/pages/product-details-page/product-details-page.component";
import {mobileWindowGuard} from "./guards/mobile-window.guard";
import {ShippingAddressComponent} from "./shipping-address/shipping-address.component";
import {PhoneVerificationComponent} from "./phone-verifiaction/phone-verification.component";
import {SubscriptionPlanComponent} from "./subscription-plan/subscription-plan.component";
import {ShippingMethodComponent} from "./shipping-method/shipping-method.component";
import {TeamsComponent} from "./teams/teams.component";
import {CardsByQrPaymentComponent} from "./cards-by-qr/cards-by-qr-payment/cards-by-qr-payment.component";
import {AcceptOrDeclinedComponent} from "./accept-or-declined/accept-or-declined.component";
import {ProductPaymentComponent} from "./product-payment/product-payment.component";
import {UsersCardsComponent} from "./admin-page/users-cards/users-cards.component";
import {ChangePasswordComponent} from "./change-password/change-password.component";
import {InsightsComponent} from "./admin-page/insights/insights.component";
import {MenuComponent} from "./admin-page/menu/menu.component";
import {MenuCreateFieldComponent} from "./admin-page/menu/menu-create-field/menu-create-field.component";
import {PromoCodeComponent} from "./admin-page/promocode/promoCode.component";
import {SubscriptionsComponent} from "./admin-page/subscriptions/subscriptions.component";
import {UsersComponent} from "./admin-page/users/users.component";
import {MySubscriptionsComponent} from "./my-subscriptions/my-subscriptions.component";
import {CardsByQrUsernameComponent} from "./cards-by-qr-username-component/cards-by-qr-username.component";
import {ActivityComponent} from "./activity/activity.component";
import {SubscriptionPaymentComponent} from "./subscription-payment/subscription-payment.component";
import {ReturnPolicyComponent} from "./return-policy/return-policy.component";
import {PaymentReceiptComponent} from "./payment-receipt/payment-receipt.component";
import {CreateCardComponent} from "./create-card/create-card.component";
import {MyInsightsComponent} from "./my-insights/my-insights.component";
import {unsavedChangesGuard} from "./guards/unsaved-changes.guard";
import {isPremiumMenuGuard} from "./guards/is-premium-menu.guard";
import {AdminProductsComponent} from "./admin-page/shop/admin-products/admin-products.component";
import {AdminOrdersComponent} from "./admin-page/shop/admin-orders/admin-orders.component";
import {AdminOrderDetailComponent} from "./admin-page/shop/admin-order-detail/admin-order-detail.component";
import {
  AdminProductManageComponent
} from "./admin-page/shop/admin-products/admin-product-save-edit/admin-product-manage.component";
import {AdminActivityComponent} from "./admin-page/admin-activity/admin-activity.component";
import {UserCardPaymentQrPageComponent} from "./user-card-payment-qr-page/user-card-payment-qr-page.component";
import {CardsByQrRatingComponent} from "./cards-by-qr/cards-by-qr-rating/cards-by-qr-rating.component";
import {
  CardsByQrManageRatingComponent
} from "./cards-by-qr/cards-by-qr-rating/cards-by-qr-manage-rating/cards-by-qr-manage-rating.component";
import {AdminQrGeneratorComponent} from "./admin-page/admin-qr-generator/admin-qr-generator.component";
import {ReservedQrCardsComponent} from "./reserved-qr-cards/reserved-qr-cards.component";
import {ReservedQrActivationPageComponent} from "./reserved-qr-activation-page/reserved-qr-activation-page.component";
import {ReviewsComponent} from "./admin-page/reviews/reviews.component";
import {FeeComponent} from "./admin-page/fee/fee.component";
import {UserFeeComponent} from "./fee/fee.component";
import {FeeGroupCreateComponent} from "./fee-group-create/fee-group-create.component";
import {FeeGroupDetailComponent} from "./fee-group-detail/fee-group-detail.component";
import {FeeAddMemberDialogComponent} from "./fee-add-member-dialog/fee-add-member-dialog.component";
import {FeeGroupPageComponent} from "./fee-group-page/fee-group-page.component";
import {FeeMemberProfileComponent} from "./fee-member-profile/fee-member-profile.component";
import {FeePaymentPageComponent} from "./fee-payment-page/fee-payment-page.component";
import {FeePaymentFormComponent} from "./fee-payment-form/fee-payment-form.component";
import {MenuViewComponent} from "./menu-view/menu-view.component";
import {MenuPaymentComponent} from "./menu-payment/menu-payment.component";
import {CommissionsComponent} from "./admin-page/commissions/commissions.component";


const routes: Routes = [
  {path: 'home', component: HomepageComponent},
  {path: 'login', component: LoginPageComponent},
  {path: 'verify-phone', component: PhoneVerificationComponent},
  {path: 'invitations/accept-or-declined', component: AcceptOrDeclinedComponent},
  {path: 'active-business-card', component: ReservedQrActivationPageComponent},
  {
    path: 'admin', component: AdminContainerComponent, children: [

      {path: 'login', component: AdminLoginPageComponent},
      {
        path: 'page', component: AdminPageComponent, canActivate: [isAuthenticatedAdminGuard], children: [
          {path: '', redirectTo: 'links', pathMatch: 'full'},
          {path: 'links', component: ContentComponent},
          {path: 'hashtag', component: HashtagComponent},
          {path: 'hashtag/edit/:id', component: EditHashtagComponent},
          {path: 'content/edit/:id', component: EditContentComponent},
          {path: 'users/cards', component: UsersCardsComponent},
          {path: 'insights', component: InsightsComponent},
          {path: 'promocode', component: PromoCodeComponent},
          {path: 'subscriptions', component: SubscriptionsComponent},
          {path: 'users', component: UsersComponent},
          {path: 'activity', component: AdminActivityComponent},
          {path: 'commissions', component: CommissionsComponent},
          {path: 'reviews', component: ReviewsComponent},
          {path: 'fees', component: FeeComponent},
          {path: 'fees/user-profile/:memberId', component: FeeMemberProfileComponent, canActivate: [feeMemberActiveGuard]},
          {path: 'fees/:id', component: FeeGroupDetailComponent},
          {path: 'fees/:id/groups/create', component: FeeGroupCreateComponent},
          {path: 'fees/:id/add-member', component: FeeAddMemberDialogComponent},
          {path: 'fees/:id/groups/:groupId', component: FeeGroupPageComponent},
          {
            path: 'shop', children: [
              {path: 'products', component: AdminProductsComponent},
              {path: 'products/manage', component: AdminProductManageComponent},
              {path: 'orders', component: AdminOrdersComponent},
              {path: 'orders/detail/:id', component: AdminOrderDetailComponent},
            ]
          },
          {path: 'qr-generator', component: AdminQrGeneratorComponent},
        ]
      }
    ]
  },
  {path: 'sign-up', component: RegistrationComponent},
  {path: 'about-us', component: AboutUsComponent},
  {path: 'products', component: ProductsComponent},
  {path: 'product/details', component: ProductDetailsPageComponent, canActivate: [mobileWindowGuard]},
  {path: 'prices', component: SubscriptionPlanComponent},
  {path: 'forgot-password', component: ForgotPasswordComponent},
  {path: 'change-password', component: ChangePasswordComponent},
  {path: 'reset-password', component: ResetPasswordComponent},
  {path: 'reset-token', component: ResetTokenExistComponent},
  {path: 'error-page', component: ErrorPageComponent},

  {path: 'privacy-policy', component: PrivacyPolicyComponent},
  {path: 'return-policy', component: ReturnPolicyComponent},
  {path: 'product/payment', component: ProductPaymentComponent},
  {path: 'cart', component: CartComponent},
  {path: 'contact-us', component: ContactUsComponent},
  {path: 'shipping-address', component: ShippingAddressComponent},
  {path: 'shipping-method', component: ShippingMethodComponent},
  {
    path: '', component: CommonComponent, canActivate: [isAuthenticatedGuard], children: [
      {path: '', redirectTo: '/home', pathMatch: 'full'},
      {path: 'cards', component: CardsComponent},
      {path: 'cards/edit/:id', component: EditProfileCardComponent, canDeactivate: [unsavedChangesGuard]},
      {path: 'history', component: CardsHistoryComponent},
      {path: 'teams', component: TeamsComponent},
      {path: 'subscriptions', component: MySubscriptionsComponent},
      {path: 'activity', component: ActivityComponent},
      {path: 'insights', component: MyInsightsComponent},
      {path: 'subscriptions/payment/:id/:isMonthly', component: SubscriptionPaymentComponent},
      {path: 'create-card', component: CreateCardComponent, canDeactivate: [unsavedChangesGuard]},
      {path: 'menu', component: MenuComponent, canActivate: [isPremiumMenuGuard]},
      {path: 'menu/add', component: MenuCreateFieldComponent, canActivate: [isPremiumMenuGuard]},
      {path: 'menu/edit/:id', component: MenuCreateFieldComponent, canActivate: [isPremiumMenuGuard]},
      {path: 'fees', component: UserFeeComponent},
      {path: 'fees/user-profile/:memberId', component: FeeMemberProfileComponent, canActivate: [feeMemberActiveGuard]},
      {path: 'fees/:id', component: FeeGroupDetailComponent},
      {path: 'fees/:id/groups/create', component: FeeGroupCreateComponent},
      {path: 'fees/:id/add-member', component: FeeAddMemberDialogComponent},
      {path: 'fees/:id/groups/:groupId', component: FeeGroupPageComponent},
    ]
  },


  {path: 'fee-payment/:token', component: FeePaymentPageComponent},
  {path: 'fee-payment/:token/pay/:recordId', component: FeePaymentFormComponent},
  {path: 'payment/receipt', component: PaymentReceiptComponent},
  {path: 'menu/view/:id', component: MenuViewComponent},
  {path: 'menu/payment/:id', component: MenuPaymentComponent},
  {path: 'q/:qrCode', component: CardsByQrUsernameComponent, canActivate: [qrCodeGuard]},
  {path: 'q/:paymentQrIdentificationId/payment', component: UserCardPaymentQrPageComponent},
  {path: 'q/:reservedIdentificationId/reserved-qr', component: ReservedQrCardsComponent},
  {path: ':qrCode', component: CardsByQrComponent, canActivate: [qrCodeGuard]},
  {path: ':qrCode/rating', component: CardsByQrRatingComponent, canActivate: [qrCodeGuard]},
  {path: ':qrCode/rating/manage', component: CardsByQrManageRatingComponent, canActivate: [qrCodeGuard]},
  {path: ':qrCode/payment', component: CardsByQrPaymentComponent, canActivate: [qrCodeGuard]},
  {path: ':qrCode/payment/:uuid/:amount', component: CardsByQrPaymentComponent, canActivate: [qrCodeGuard]},
  {path: '**', redirectTo: 'error-page'}
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    scrollPositionRestoration: "top",
    anchorScrolling: "disabled"
  })],
  exports: [RouterModule]
})
export class AppRoutingModule {

}
